import ApiService from "@/api";

// import { ResponseTaskModel } from "@/models";
import { ResponseModel, TaskHistoryModel } from "../models";
import { mapGetTaskHistoryRequest, mapGetTaskHistoryResponse } from "./AdapterServiceMappers";
import PageRequest from "@/api/Main/dataSource/api/pagination-helper/lib/PageRequest";
import PageResponse from "@/api/Main/dataSource/api/pagination-helper/lib/PageResponse";

export class AdapterService {
  private readonly api = new ApiService();

  /**
   * * Получить список неймспейсов
   * @param taskId ID проекта
   * @returns
   */
  getTaskHistory(taskId: number, pagination: PageRequest) {
    return new Promise<ResponseModel<{ Items: Array<TaskHistoryModel>; Page: PageResponse }>>(
      async (resolve) => {
        const result = new ResponseModel<{ Items: Array<TaskHistoryModel>; Page: PageResponse }>();

        await this.api.Main.TaskActionHistoryService.getActionHistoryListAsync(
          mapGetTaskHistoryRequest(taskId, pagination),
        )
          .then((resp) => {
            result.Value = mapGetTaskHistoryResponse(resp);
            return resolve(result);
          })
          .catch((e) => {
            result.IsSuccess = false;
            result.ErrorCode = e?.ErrorCode;
            result.ErrorMessage = e?.ErrorMessage;
            console.error("ERROR getHistory", e);
            return resolve(result);
          });
      },
    );
  }
  //   subscribeGetTaskHistory() {
  //     this.api.Main.TaskActionHistoryService.GetActionHistoryListEvent.on((updatedData) => {
  //       console.log(11223344);
  //       console.log(updatedData);
  //     });
  //   }
}
